import { matchPath } from 'react-router-dom';
import { Routes } from 'constants/routeConstants';
import { RETURN_URL_STORAGE_KEY } from 'modules/auth/constants';

export const validPath = (menuItem, pathname) => {
  const iPath = menuItem.routePath || menuItem.path;
  return matchPath(pathname, iPath);
};

export const getDefaultPath = (authenticated, isAdmin, isCountryManager, isManager) => {
  let returnUrlInfo = sessionStorage.getItem(RETURN_URL_STORAGE_KEY);
  returnUrlInfo = returnUrlInfo ? JSON.parse(returnUrlInfo) : null;
  let path = Routes.MY_ACCOUNTS;

  if (!authenticated) {
    path = Routes.SIGNIN;
  } else if (returnUrlInfo && returnUrlInfo?.pathname) {
    sessionStorage.removeItem(RETURN_URL_STORAGE_KEY);
    if (returnUrlInfo.pathname !== Routes.HOME || returnUrlInfo.search) {
      path = returnUrlInfo.pathname + returnUrlInfo.search;
    } else {
      path = getDefaultPath(authenticated, isAdmin, isCountryManager, isManager);
    }
  } else if (isAdmin || isCountryManager) {
    path = Routes.DASHBOARD;
  } else if (isManager) {
    path = Routes.VERIFICATION_MANAGEMENT;
  }

  return path;
};
